import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const StyledHeader = styled(Box)`
  padding: 0.25rem;
  background-color: ${(props) => props.theme.palette.header.main};
  ${(props) =>
    props.cover
      ? `
    display: flex;
    align-items: center;
    padding: .25rem; 
  `
      : ''};

  @media (min-width: 900px) and (min-height: 900px) {
    padding: 0.5rem;
  }
  @media (max-height: 681px) and (min-width: 900px) {
    height: 2.5rem;
  }

  .endbutton {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }
`;
